import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useCurrentUserStore } from "@src/state/currentUserState";
import { getHasRole } from "@src/utils/permission";

interface PortalGuardRouteProps {
  role: string;
}

export default function PortalGuardRoute({
  role,
}: PortalGuardRouteProps): React.JSX.Element | null {
  const { currentUser, loading } = useCurrentUserStore();

  if (loading || !currentUser) return null;

  return getHasRole(currentUser, role) ? (
    <Outlet />
  ) : (
    <Navigate to="/" replace />
  );
}
